export const getTwitterProfileImage = (username: string): string => {
	return `https://unavatar.io/twitter/${username}`
}

// Helper: Extract Twitter username
export const extractTwitterUsername = (url: string): string | null => {
	try {
		const urlObj = new URL(url)
		const hostname = urlObj.hostname.toLowerCase()
		const path = urlObj.pathname
		if (hostname === 'twitter.com' || hostname === 'x.com') {
			return path.replace(/^\/|\/$/g, '')
		}
		return null
	} catch {
		return null
	}
}

// Helper: Get initials
export const getInitials = (name?: string | null) => {
	if (!name) return '?'
	return name
		.split(' ')
		.map((part) => part[0])
		.join('')
		.toUpperCase()
}
